import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import './SiteMap.scss';
import Arrow2 from '../../Images/Arrow2.svg'

// import { useLocation } from "react-router-dom";
import NavigatorPath from "../../Tools/NavigatorPath/NavigatorPath"
import { useEffect } from 'react';


export default function SiteMap({ CitiesArray, CarPath, MakersArray, Inventory, Categories, Blogs, WebSitePages }) {
    const location = useLocation()
    const [SiteMapToArray, setSiteMapToArray] = useState([]);


    useEffect(() => {
        if (location.pathname.split('/')[2] == "website" || location.pathname.split('/')[1] == "sitemaps" || location.pathname.split('/').length <= 2 && location.pathname.split('/')[1] == "sitemap") {
            setSiteMapToArray(WebSitePages)
        } else if (location.pathname.split('/')[2] == "categories") {
            console.log("yes")
            setSiteMapToArray(Categories)
        } else if (location.pathname.split('/')[2] == "makes") {
            setSiteMapToArray(MakersArray)
        } else if (location.pathname.split('/')[2] == "inventory") {
            setSiteMapToArray(Inventory)
        } else if (location.pathname.split('/')[2] == "blog") {
            setSiteMapToArray(Blogs)
        } else if (location.pathname.split('/')[2] == "florida") {
            setSiteMapToArray(CitiesArray.filter(a => a.StateId == 'FL'))
        } else if (location.pathname.split('/')[2] == "california") {
            setSiteMapToArray(CitiesArray.filter(a => a.StateId == 'CA'))
        }
    }, [location.pathname]);
    console.log(CitiesArray)

    return (
        <div className="SiteMap">
            <div className="SiteMapMenu">
                <a style={location.pathname.split('/')[2] == "website" || location.pathname.split('/')[1] == "sitemaps" || location.pathname.split('/').length <= 2 && location.pathname.split('/')[1] == "sitemap" ? { "borderBottom": "1px solid #0f212e" } : null} href="/sitemap/website">Website</a>
                <a style={location.pathname.split('/')[2] == "categories" ? { "borderBottom": "1px solid #0f212e" } : null} href="/sitemap/categories">Categories</a>
                <a style={location.pathname.split('/')[2] == "makes" ? { "borderBottom": "1px solid #0f212e" } : null} href="/sitemap/makes">Makes</a>
                <a style={location.pathname.split('/')[2] == "inventory" ? { "borderBottom": "1px solid #0f212e" } : null} href="/sitemap/inventory">Inventory</a>
                <a style={location.pathname.split('/')[2] == "blog" ? { "borderBottom": "1px solid #0f212e" } : null} href="/sitemap/blog">Blog</a>
                <a style={location.pathname.split('/')[2] == "florida" ? { "borderBottom": "1px solid #0f212e" } : null} href="/sitemap/florida">Florida</a>
                <a style={location.pathname.split('/')[2] == "california" ? { "borderBottom": "1px solid #0f212e" } : null} href="/sitemap/california">California</a>
            </div>
            <div className="SiteMapDes">
                {location.pathname.split('/')[2] == "website" || location.pathname.split('/')[1] == "sitemaps" || location.pathname.split('/').length <= 2 && location.pathname.split('/')[1] == "sitemap" ?
                    <div className='SiteMapDesBox'>
                        {SiteMapToArray.map((A, index) =>
                            <a key={index} href={`${A.Path}`}>{A.Name}</a>
                        )}
                    </div>
                    : location.pathname.split('/')[2] == "categories" ?
                        <div className='SiteMapDesBox'>
                            <a href="/categories">Exotic Car Rentals Categories</a>
                            {SiteMapToArray.map((A, index) =>
                                <a key={index} href={`/categories/${A.Type.toLowerCase()}`}>{A.Type}</a>
                            )}
                        </div>
                        : location.pathname.split('/')[2] == "makes" ?
                            <div className='SiteMapDesBox'>
                                <a href="/makes">Exotic Car Rentals Makes</a>
                                {SiteMapToArray.map((A, index) =>
                                    <a key={index} href={`/makes/${A.MakersId.toLowerCase()}`}>{A.Makers}</a>
                                )}
                            </div>
                            : location.pathname.split('/')[2] == "inventory" ?
                                <div className='SiteMapDesBox'>
                                    <a href="/cars">Exotic Car Rentals Inventory</a>
                                    {SiteMapToArray.map((A, index) =>
                                        <a key={index} href={`/cars/${CarPath(index)}`}>{A.FullName}</a>
                                    )}
                                </div>
                                : location.pathname.split('/')[2] == "blog" ?
                                    <div className='SiteMapDesBox'>
                                        <a href="/blog">Exotic Car Rentals Blog And Magazine</a>
                                        {SiteMapToArray.map((A, index) =>
                                            <a key={index} href={`/blog/${A.BlogPath.replace(/ /g, "_") + "_" + index}`}>{A.BlogPath}</a>
                                        )}
                                    </div>
                                    : location.pathname.split('/')[2] == "florida" ?
                                        <div className='SiteMapDesBox'>
                                            <a href="/florida/miami">Exotic Car Rentals Florida</a>
                                            {SiteMapToArray.map((A, index) =>
                                                <a key={index} href={`/florida/${A.CityId}`}>Exotic & Luxury Car Rentals In {A.City}</a>
                                            )}
                                        </div>
                                        : location.pathname.split('/')[2] == "california" ?
                                            <div className='SiteMapDesBox'>
                                                <a href="/california/losangeles">Exotic Car Rentals California</a>
                                                {SiteMapToArray.map((A, index) =>
                                                    <a key={index} href={`/california/${A.CityId}`}>Exotic & Luxury Car Rentals In {A.City}</a>
                                                )}
                                            </div>
                                            : null
                }

            </div>


            <NavigatorPath />

        </div>
    )
}
